import { gql } from "@apollo/client";

export const SET_ORGANIZATION_MEMBERSHIP = gql`
  mutation SetOrganizationMembership($input: SetOrganizationMembershipInput!) {
    setOrganizationMembership(input: $input)
  }
`;
